/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, css } from '@emotion/react';

import { useTranslation } from 'react-i18next';
import Text from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import CopyIcon from '@mui/icons-material/FileCopyOutlined';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';

import { copyToClipboard } from '../../utils/clipboard';
import { useUserQuery } from '../../actions/UserActions';

import { CALENDAR_RECIPIENT_PREFIX } from '../../constants';

export default function UploadCalendar({ handleClose }) {
  const { t } = useTranslation();
  const { user } = useUserQuery();

  return (
    <div>
      <Text variant="subtitle2" color="textSecondary" fontWeight="600">
        {t(
          'Bjud med Klang i dina kalenderinbjudningar för automatisk transkribering. Skicka ett mejl med kalendern inbjudan till e-postadressen ned'
        )}
      </Text>
      <Text
        css={css`
          margin-top: 0.5rem;
          margin-bottom: 0.25rem;
        `}
        fontWeight="600"
      >
        E-postadress
      </Text>
      <TextField
        value={`${CALENDAR_RECIPIENT_PREFIX}+${user?.invite_email}@klang.ai`}
        fullWidth
        InputProps={{
          readOnly: true,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() =>
                  copyToClipboard(
                    `${CALENDAR_RECIPIENT_PREFIX}+${user?.invite_email}@klang.ai`
                  )
                }
              >
                <CopyIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </div>
  );
}
